import { render } from "./ConsultationProceduresResultsQueueTab.vue?vue&type=template&id=75da3680"
import script from "./ConsultationProceduresResultsQueueTab.vue?vue&type=script&lang=js"
export * from "./ConsultationProceduresResultsQueueTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__